import React, {useRef, useState} from 'react';
import {Dialog} from "primereact/dialog";
import {useTranslate} from "../../../system/useTranslate";
import {Button} from "primereact/button";
import Icon from "../../../system/components/icon";
import {useSelector} from "react-redux";
import InputLabel from "../../../system/components/input-label";
import SelectMembers from "../../tasks/components/select-members";
import SelectMember from "../../tasks/components/select-member";
import {useUpdateEffect} from "primereact/hooks";
import {Avatar as PrimeAvatar} from "primereact/avatar";
import {OverlayPanel} from "primereact/overlaypanel";
import SelectIcon from "../../tasks/components/select-icon";
import {Divider} from "primereact/divider";
import {ColorPicker} from "primereact/colorpicker";
import {ListBox} from "primereact/listbox";
import MultiSelectProjects from "../../projects/components/multi-select-projects";
import MultiSelectGoals from "../../goals/components/multi-select-goals";

function CreateTeamDialog({visible, setVisible, teamData, onSubmit}) {

    const translate = useTranslate();
    const [newTeamData, setNewTeamData] = useState({owner: null});
    const {workspaceMembershipData} = useSelector((state) => state.app);


    const updateTeamProjects = (value)=>{

        let _projects = [...newTeamData?.projects??[]]
        if (value?.status==="added"){
            _projects = [..._projects, value.projectData];
        }
        if (value?.status==="removed"){
            _projects = _projects.filter(p=>p.id!==value.projectData.id);

        }
        setNewTeamData({...newTeamData, projects:_projects})
    }

    const updateTeamGoals = (value)=>{

        let _goals = [...newTeamData?.goals??[]]
        if (value?.status==="added"){
            _goals = [..._goals, value.goalData];
        }
        if (value?.status==="removed"){
            _goals = _goals.filter(p=>p.id!==value.goalData.id);

        }
        setNewTeamData({...newTeamData, goals:_goals})
    }

    const submit = ()=>{
        let _newTeamData = {...newTeamData};
        if (_newTeamData?.members)_newTeamData = {..._newTeamData, members:_newTeamData?.members.map(m=>m.id)};
        if (_newTeamData?.goals)_newTeamData = {..._newTeamData, goals:_newTeamData?.goals.map(g=>g.id)};
        if (_newTeamData?.projects)_newTeamData = {..._newTeamData, projects:_newTeamData?.projects.map(p=>p.id)};
        if (_newTeamData?.owner)_newTeamData = {..._newTeamData, owner:_newTeamData?.owner.id};
        onSubmit?.({value: _newTeamData})
    }

    return (
        <Dialog pt={{footer:()=>({className:"p-0 border-round-bottom-2xl"}), content:()=>({className:"p-0 h-full"})}} header={<Header teamData={teamData}/>} contentClassName="p-4" headerClassName="border-round-top-2xl border-bottom-1 border-300 pb-3 pt-3" footer={<Footer setVisible={setVisible} onSubmit={submit}/>} className="rtl w-6 border-round-bottom-2xl" visible={visible} onHide={()=>{setVisible(false)}}>
            <div className="flex flex-column gap-3">
                <div className="flex flex-wrap gap-2 w-full">
                    <InputLabel require className="flex-1" inputType="TEXT" label={translate("team-name")} value={newTeamData?.name ?? teamData?.name ?? ""} onChange={(e)=>{setNewTeamData({...newTeamData, name:e.target.value})}}/>
                    <InputLabel className="flex-1" label={translate("team-owner")}>
                        <SelectMember primeDropdown={true} ariaLabel={translate("team-owner")} selectedMember={newTeamData?.owner || teamData?.owner} onChange={(membership)=>{setNewTeamData({...newTeamData, owner:membership})}} hideLabel={false} members={workspaceMembershipData?.workspace?.workspace_memberships || []}/>
                    </InputLabel>
                </div>
                <InputLabel className="flex-1" label={translate("team-color")}>
                    <IconColorPicker value={newTeamData?.iconColor||teamData?.iconColor} onChange={(e)=>{setNewTeamData({...newTeamData, iconColor:e.value})}}/>
                </InputLabel>
                <InputLabel className="flex-1" label={translate("add-members")}>
                    <SelectMembers
                        allowEmpty
                        className="w-full min-h-3rem border-1 border-300 border-round p-2"
                        selectedMembers={newTeamData?.members || teamData?.members || []}
                        members={workspaceMembershipData?.workspace?.workspace_memberships || []}
                        onChange={(event) => setNewTeamData({...newTeamData, members: event.members})}
                    />
                </InputLabel>
                <div className="flex gap-3">
                    <SelectProjects value={newTeamData?.projects||[]} options={workspaceMembershipData?.workspace?.projects.filter(p=>!p.team)} onChange={(e)=>{updateTeamProjects(e)}}/>
                    <SelectGoals value={newTeamData?.goals||[]} options={workspaceMembershipData?.workspace?.goals.filter(g=>!g.team)} onChange={(e)=>{updateTeamGoals(e)}}/>
                </div>

            </div>
        </Dialog>
    );
}

function IconColorPicker({value, onChange}) {

    const ref = useRef();
    const [colorIcon, setColorIcon] = useState(value)
    const colors = ["red","blue","purple","green","orange"]
    const colorPickerRef = useRef();
    useUpdateEffect(()=>{
        onChange?.({value:colorIcon});
    },[colorIcon])

    return(
        <div className="flex align-items-center gap-2">
            <PrimeAvatar onClick={(e)=>{ref.current.toggle(e)}} shape="circle" size="large" className="border-2 border-dashed border-300" icon={<Icon icon={value?.icon||"mi mi:image"}/>}/>
            <OverlayPanel ref={ref}>
                <SelectIcon onChange={(e)=>{setColorIcon({...colorIcon, icon:e});ref.current.hide()}}/>
            </OverlayPanel>
            <Divider className="m-1" layout="vertical"/>
            {colors.map(c=><PrimeAvatar onClick={()=>{setColorIcon({...colorIcon, color:c})}} icon={c===value?.color&&<Icon icon="mi mi:check" className="text-white"/>} className="cursor-pointer border-2 border-white shadow-2" shape="circle" size="normal" style={{backgroundColor:c}}/>)}
            <PrimeAvatar style={{backgroundColor:colorIcon?.color}} shape="circle" onClick={(e)=>{colorPickerRef.current.toggle(e)}} className="border-2 border-dashed border-300 cursor-pointer" icon={<Icon icon="mi mi:add" className="text-400"/>}/>
            <OverlayPanel pt={{root:()=>({className:"p-0"}),content:()=>({className:"p-1"})}} ref={colorPickerRef}>
                <ColorPicker inline pt={{input:()=>({className:"border-400",style:{borderRadius:'20px', border:"dashed 2px"}})}} value={colorIcon?.color} onChange={(e) => {setColorIcon({...colorIcon, color:`#${e.value}`});}} />
            </OverlayPanel>
        </div>
    )
}

function SelectProjects({value, options, onSelect, onChange}) {

    const translate = useTranslate();
    const ref = useRef();
    const ItemTemplate = (data)=>{
        return(
            <div className="flex gap-2 align-items-center text-xs">
                <span>{data?.title}</span>
            </div>
        )
    }


    return(
        <div className="w-full flex flex-column ">
            <div className="flex align-items-center justify-content-between">
                <span className="p-2 text-xs">{translate("projects")}</span>
                <Icon icon="mi mi:add_circle" className="text-lg" onClick={(e)=>{ref.current.toggle(e)}}/>
                {/*<Button onClick={(e)=>{}} className="w-full p-button-outlined p-button-secondary shadow-none text-xs p-2 " icon={} />*/}
            </div>
            <div className="surface-100 flex flex-column border-1 border-round border-100">
                <OverlayPanel pt={{root:()=>({className:"p-0 rtl"}),content:()=>({className:"p-0"})}} ref={ref}>
                    <MultiSelectProjects onChange={onChange} options={options} value={value}/>
                </OverlayPanel>
                <ListBox dataKey="id" pt={{item:(e)=>({className:`${e.context.selected&&"border-right-3"}`})}} itemTemplate={ItemTemplate} options={value||[]} className="border-none border-noround"/>
            </div>
        </div>
    )
}

function SelectGoals({value, options, onSelect, onChange}) {

    const translate = useTranslate();
    const ref = useRef();
    const ItemTemplate = (data)=>{
        return(
            <div className="flex gap-2 align-items-center text-xs">
                <span>{data?.title}</span>
            </div>
        )
    }


    return(
        <div className="w-full flex flex-column ">
            <div className="flex align-items-center justify-content-between">
                <span className="p-2 text-xs">{translate("goals")}</span>
                <Icon icon="mi mi:add_circle" className="text-lg" onClick={(e)=>{ref.current.toggle(e)}}/>
                {/*<Button onClick={(e)=>{}} className="w-full p-button-outlined p-button-secondary shadow-none text-xs p-2 " icon={} />*/}
            </div>
            <div className="surface-100 flex flex-column border-1 border-round border-100">
                <OverlayPanel pt={{root:()=>({className:"p-0 rtl"}),content:()=>({className:"p-0"})}} ref={ref}>
                    <MultiSelectGoals onChange={onChange} options={options} value={value}/>
                </OverlayPanel>
                <ListBox dataKey="id" pt={{item:(e)=>({className:`${e.context.selected&&"border-right-3"}`})}} itemTemplate={ItemTemplate} options={value||[]} className="border-none border-noround"/>
            </div>
        </div>
    )
}


function Header({teamData}) {
    const translate = useTranslate();
    return(
        <div className="flex flex-column">
            <span className="text-lg">{translate("create-team")}</span>
            <span className="text-xs text-400">{teamData?.name}</span>
        </div>
    )
}
function Footer({setVisible, onSubmit}) {
    const translate = useTranslate();
    return(
        <div className="flex flex-row-reverse align-items-center gap-2 justify-content-start p-3 surface-50 border-round-bottom-2xl border-top-1 border-300">
            <Button icon={<Icon icon="mi mi:save" className="text-lg"/>} className="text-xs flex gap-2 border-round-lg p-2" label={translate("save-changes")} onClick={onSubmit}/>
            <Button className="text-xs p-button-secondary p-button-outlined border-round-lg p-2" label={translate("cancel")} onClick={()=>{setVisible(false)}}/>
        </div>
    )
}

export default CreateTeamDialog;
